import { EMOTION_CLIPS, emotionClipPath } from "@/content/emotion-script"
import TIMINGS from "@/content/emotion-timings.json"
import { timingFor, type Word } from "@/lib/timings"

export type Line = { lang: string; src: string; words: Word[] }

export type Clip = { emotion: string; source: Line; translation: Line }

// Generated by `pnpm audio:emotions`: the same voice and emotion tag read
// both languages, with word timings from the API.
export const CLIPS: Clip[] = EMOTION_CLIPS.map((clip) => {
  const line = (part: "source" | "translation"): Line => {
    const { lang, text } = clip[part]
    const src = emotionClipPath(clip, part)
    const { words } = timingFor(TIMINGS, src)
    if (words.length !== text.split(" ").length) {
      throw new Error(`Timings for ${src} are out of date`)
    }
    return { lang: lang.toUpperCase(), src, words }
  }
  return {
    emotion: clip.emotion,
    source: line("source"),
    translation: line("translation"),
  }
})
